import React, { useState, useEffect, useContext, Fragment } from 'react';
import useLocality from '../../../../../hooks/useLocality';
import { ProjectContext } from '../../../../../context/Project';
import {
	Container,
	Row,
	Col,
	Input,
	FormGroup,
	Label,
	FormFeedback
} from "reactstrap";
import '../steps.scss';
import { PixelContext } from '../../../../../context/Pixel';

function Location() {
	const [zipCode, setZipcode] = useState('');
	const [zipCodeValid, setZipcodeValid] = useState(false);
	const [zipCodeLocality, setZipcodeLocality] = useState('');
	
	const localityHelper = useLocality();
	const { setLocation, setPostalCode, getPostalCode } = useContext(ProjectContext);
	const { trackAnalyticsEvent, Events } = useContext(PixelContext);
	const zipCodeLengthValid = zipCode.length > 4;

	const handleZipCodeChange = (event) => {
        setZipcode(event.target.value);
		setZipcodeLocality('');
    }

	useEffect(() => {
		let postalCode = getPostalCode();

		if (postalCode) {
			setZipcode(postalCode)
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

	useEffect(() => {
		if (zipCodeLengthValid) {
			localityHelper.getByPostalCode(1, zipCode);
		} else {
			setZipcodeValid(false);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCode]);

	useEffect(() => {
		if (!zipCodeValid) {
			setLocation(null);
			setPostalCode(null);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCodeValid]);

	useEffect(() => {
		if(localityHelper.loading) {
			return;
		}

        if(localityHelper.localitiesByPostalCode && localityHelper.localitiesByPostalCode.length) {
			const localityData = localityHelper.localitiesByPostalCode.find(() => true);
			setZipcodeValid(true);
			setLocation(localityData);
			setPostalCode(zipCode);
			setZipcodeLocality(`${localityData.name}, ${localityData.administrativeAreaName}`);
			trackAnalyticsEvent(Events.ADD_ITEMS_ZIP_CODE_SET, {
				zipCode: zipCode
			});
        } else {
			setZipcodeValid(false);
		}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localityHelper.localitiesByPostalCode]);

    return (
		<Fragment>
			<Container className="builde-cont">
				<Row>
					<Col xs={{ size: 6 }}>
						<FormGroup floating className="m-t-30">
							<Input
								id="zipcode"
								name="zipcode"
								placeholder="ZIP code"
								type="text"
								value={zipCode}
								onChange={handleZipCodeChange}
								valid={zipCodeValid}
							/>
							<Label for="zipcode">
								ZIP code
							</Label>
							{
								(zipCodeValid && zipCodeLocality) &&
								<FormFeedback valid>
									{zipCodeLocality}
								</FormFeedback>
							}
						</FormGroup>
					</Col>
					<Col xs={{ size: 6 }}>
						<FormGroup floating className="m-t-30 font-helvetica-world">
							<div className='hint-container align-content-center'>
								<span>
									Currently, only available for the Chicago area.
								</span>
							</div>
						</FormGroup>
					</Col>
				</Row>
			</Container>
		</Fragment>
    );
}

export default Location;